// EmailJS Configuration
export const EMAILJS_CONFIG = {
  publicKey: 'A6r5imixTkcaqo2b3', 
  serviceId: 'service_e1m78cr', 
  adminTemplateId: 'template_bszstfp',
  confirmationTemplateId: 'template_294mzgw', 
};